import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { Hazard, NewTaskTakeFive } from "../../../shared/models/api/models";
import { HazardCard } from "./HazardCard";
import { HazardForm } from "./HazardForm";
import Modal from "./Modal";
import {
    takeFiveFormState as t,
    TakeFiveFormState
} from "./TakeFiveFormState";

interface HazardsProps {
    open: boolean;
    onClose: () => void;
}

export const Hazards = (props: HazardsProps) => {
    const [hazardList, setHazardList] = useState([] as Hazard[] | undefined);
    const [form, setForm] = useState({} as NewTaskTakeFive);
    const [editingHazard, setEditingHazard] = useState(null as Hazard | null);

    // Modal
    const [open, setOpen] = useState(false);
    const showModal = () => setOpen(true);
    const hideModal = () => setOpen(false);

    useEffect(() => {
        const sub = t.subscribe((s: TakeFiveFormState) => {
            setForm(s.form);
            setHazardList(s.form.taskHazards);
        });

        return () => { sub.unsubscribe(); };
    }, [open]);

    const handleEditHazard = (hazard: Hazard) => {
        setEditingHazard(hazard);
        showModal();
    };

    const handleAddHazard = () => {
        setEditingHazard(null);
        showModal();
    };

    const handleCloseModal = () => {
        setEditingHazard(null);
        hideModal();
    };

    return (
        <>
            <div className="tf-risks-list-container">
            {hazardList !== undefined && hazardList.length > 0 ?
                <div>
                    {hazardList?.map((item) => (
                        <HazardCard item={ item } onEdit={handleEditHazard}></HazardCard>
                    ))}
                </div>
                :
                <div className="no-hazards">
                    Add a hazard to view information here
                </div>
            }
            <Modal open={open} onClose={handleCloseModal}>
                <HazardForm open={open} onClose={ handleCloseModal } editingHazard={editingHazard}></HazardForm>
            </Modal>
        </div>
        <div className="submit btns-container">
            <Button className="btn-primary" onClick={handleAddHazard}>Add Hazard</Button>
            <Button className="btn-primary btn-spacing" onClick={() => { props.onClose() }}>Close</Button>
        </div>
        </>
    );
}
